import React from 'react';
import { useNavigate } from 'react-router-dom';
import { resolveImage } from '../../utils/storageUrl';
import './CarCard.css';

const CarCard = ({ car, isUsed }) => {
    const navigate = useNavigate();

    const handleCardClick = () => {
        navigate(`/catalog/${isUsed ? 'used' : 'new'}/${car.id}`);
    };

    return (
        <div className="car-card" onClick={handleCardClick} role="button" tabIndex={0}
            onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') handleCardClick();
            }}
        >
            <div className="car-card-image-container">
                <img
                    src={resolveImage(car.image_path)}
                    alt={car.name}
                    className="car-card-image"
                />
            </div>
            <div className="car-card-info">
                <h3 className="car-card-name">{car.name}</h3>

                <div className="car-card-details">
                    <span>{car.year} г.</span>
                    <span>•</span>
                    <span>{car.body_type}</span>
                </div>

                <div className="car-card-price-row">
                    <span className="car-card-price">
                        {new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'EUR',
                            maximumFractionDigits: 0
                        }).format(car.displayPrice)}
                    </span>

                    {car.pdf_file && (
                        <a
                            href={resolveImage(car.pdf_file)}
                            target="_blank"
                            rel="noreferrer"
                            onClick={(e) => e.stopPropagation()} // важно: не даём клику всплыть до onClick карточки
                            className="car-card-pdf-link"
                        >
                            PDF Спецификация
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CarCard;